<template>
    <div class="d-flex flex-column flex-root" v-if="isAuthenticated">
        <!-- begin:: Header Mobile -->
        <KTHeaderMobile></KTHeaderMobile>
        <!-- end:: Header Mobile -->

        <Loader v-if="loaderEnabled" v-bind:logo="loaderLogo"></Loader>
        <!-- begin::Body -->
        <div class="d-flex flex-row flex-column-fluid page">
            <div id="kt_wrapper" class="d-flex flex-column flex-row-fluid wrapper">
                <!-- begin:: Header -->
                <KTHeader></KTHeader>
                <!-- end:: Header -->

                <!-- begin:: Content -->
                <div id="kt_content" class="content d-flex flex-column flex-column-fluid">
                    <!-- begin:: Content Head -->
                    <KTSubheader v-if="subheaderDisplay" v-bind:account="account" />
                    <!-- end:: Content Head -->

                    <!-- begin:: Content Body -->
                    <div class="d-flex flex-column-fluid">
                        <div :class="{'container-fluid': contentFluid, container: !contentFluid}">
                            <transition name="fade-in-up">
                                <router-view />
                            </transition>
                        </div>
                    </div>
                </div>
                <KTFooter></KTFooter>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import { VERIFY_AUTH } from "@/store/auth.module";
import KTAside from "@/views/layout/aside/Aside.vue";
import KTHeader from "@/views/layout/header/Header.vue";
import KTHeaderMobile from "@/views/layout/header/HeaderMobile.vue";
import KTFooter from "@/views/layout/footer/Footer.vue";
import HtmlClass from "@/core/services/htmlclass.service";
import KTSubheader from "@/views/layout/subheader/Subheader.vue";
import KTStickyToolbar from "@/views/layout/extras/StickyToolbar.vue";
import KTScrollTop from "@/views/layout/extras/ScrollTop";
import Loader from "@/views/content/Loader.vue";
import redirect from "@/core/config/status.code";

import {ADD_BODY_CLASSNAME, REMOVE_BODY_CLASSNAME} from "@/store/htmlclass.module.js";

export default {
    name: "Layout",
    components: {
        KTAside,
        KTHeader,
        KTHeaderMobile,
        KTFooter,
        KTSubheader,
        KTStickyToolbar,
        KTScrollTop,
        Loader
    },
    beforeMount() {
        this.$store.dispatch(ADD_BODY_CLASSNAME, "page-loading");
        HtmlClass.init(this.layoutConfig());
    },
    mounted() {
        if (!this.isAuthenticated) 
            this.$router.push({ name: "login" });

        this.$store.dispatch(VERIFY_AUTH)
        .then(() => {this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");})
        .catch((err)=>{
        this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
        this.$alert(err.statusText + '\n' + (err.data !='' ? err.data.message : ''), 'Error ' + err.status, {
            type: 'warning',
            confirmButtonText: 'Entendido',
            callback: action => {
                redirect.Manager(err.status);
            }
        });
        });
    },
    computed: {
        ...mapGetters([
            "account",
            "isAuthenticated",
            "breadcrumbs",
            "pageTitle",
            "layoutConfig"
        ]),
        loaderEnabled() {
            return !/false/.test(this.layoutConfig("loader.type"));
        },
        contentFluid() {
            return this.layoutConfig("content.width") === "fluid";
        },
        loaderLogo() {
            return process.env.BASE_URL + this.layoutConfig("loader.logo");
        },
        asideEnabled() {
            return !!this.layoutConfig("aside.self.display");
        },
        toolbarDisplay() {
            return true;
        },
        subheaderDisplay() {
            return !!this.layoutConfig("subheader.display");
        }
    }
}
</script>